import { Injectable } from '@angular/core';
import { ApiConfigService } from './api-config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DeviceModelItem } from '../../models/device-model.interface';

@Injectable({
  providedIn: 'root'
})
export class DeviceModelService {
  private get apiUrl(): string { return `${this.apiConfig.apiUrl}/device-models`; }

  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {}

  getDeviceModels(): Observable<DeviceModelItem[]> {
    return this.http.get<DeviceModelItem[]>(this.apiUrl);
  }

  createDeviceModel(data: { name: string; brand?: string; availability?: string; inStock?: boolean; material?: string }): Observable<DeviceModelItem> {
    return this.http.post<DeviceModelItem>(this.apiUrl, data);
  }

  updateDeviceModel(id: string, data: Partial<DeviceModelItem>): Observable<DeviceModelItem> {
    return this.http.put<DeviceModelItem>(`${this.apiUrl}/${id}`, data);
  }

  deleteDeviceModel(id: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`);
  }

  parseStockExcel(file: File): Observable<{
    success: boolean;
    fileName: string;
    sheetNames: string[];
    totalModels: number;
    brands: Array<{ name: string; count: number; avl: number; oos: number }>;
    detectedMaterial: string;
    models: Array<{ rowNumber: number; sheet: string; brand: string; name: string; availability: string; inStock: boolean }>;
  }> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<any>(`${this.apiUrl}/parse-stock-excel`, formData);
  }

  bulkImport(data: {
    models: any[];
    material?: string;
    createBrands?: boolean;
    createMaterial?: boolean;
    updateExisting?: boolean;
  }): Observable<{
    success: boolean;
    totalProcessed: number;
    createdCount: number;
    updatedCount: number;
    brandsCount: number;
    brandsCreated: number;
    material?: string;
  }> {
    return this.http.post<any>(`${this.apiUrl}/bulk-import`, data);
  }

  downloadStockTemplate(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/stock-template`, { responseType: 'blob' });
  }
}



